import type { MfaSetup } from '../../lib/types';

/** Steps 1-2 of adding the account to Google Authenticator: the QR code and the key to type instead. */
export function AuthenticatorSetup({ setup }: { setup: MfaSetup }) {
  return (
    <>
      <ol className="security-steps">
        <li>Install Google Authenticator on your phone from the App Store or Google Play.</li>
        <li>
          In the app, tap <strong>+</strong> and then <strong>Scan a QR code</strong>, and scan this code:
        </li>
      </ol>
      <img className="security-qr" src={setup.qrCode} alt="QR code to add this account to your authenticator app" />
      <p className="field-hint">
        Can't scan it? Choose <strong>Enter a setup key</strong> and type this key, with the time-based option:
        <br />
        <span className="mono security-secret">{setup.secret.replace(/(.{4})/g, '$1 ').trim()}</span>
      </p>
      <ol className="security-steps" start={3}>
        <li>Enter the 6-digit code the app now shows.</li>
      </ol>
    </>
  );
}
